import React from "react";

export default function CheckboxIcon({ size=16, color="#79808A" }: { size?: number, color?: string }) {
    return (
        <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="1.125" y="1.125" width="13.75" height="13.75" rx="2.70833" stroke={color} strokeWidth="1.25"/>
        </svg>
    )
}